import format from '../plugins/baseFormat';

export default class ShipmentArea {
  constructor (initialData = {},) {
    const {
      _id,
      fence_id,
      cityfence_id,
      city_id,
      district_id,
      district_name,
      base_price,
      store_price,
      client_price,
      surcharge,
    } = initialData;

    (this._id = _id),
    (this.fence_id = fence_id),
    (this.cityfence_id = cityfence_id),
    (this.city_id = city_id),
    (this.district_id = district_id),
    (this.district_name = district_name),
    (this.base_price = base_price),
    (this.store_price = store_price),
    (this.client_price = client_price),
    (this.surcharge = surcharge);
  }

  get formatted_base_price () {
    if (this.base_price === null || this.base_price === undefined) {return '-';}
    return format.money(this.base_price,);
  }

  get formatted_store_price () {
    if (this.store_price === null || this.store_price === undefined) {return '-';}
    return format.money(this.store_price,);
  }

  get formatted_client_price () {
    if (this.client_price === null || this.client_price === undefined) {return '-';}
    return format.money(this.client_price,);
  }

  get formatted_surcharge () {
    if (this.surcharge === null || this.surcharge === undefined) {return '-';}
    return format.money(this.surcharge,);
  }

}
